export const LECTURE_CACHE_TTL_MS = 12 * 60 * 60 * 1000; // 12시간

export function isCacheExpired(savedAt, ttl = LECTURE_CACHE_TTL_MS) {
    return Date.now() > savedAt + ttl;
}